// extracted by mini-css-extract-plugin
export var link = "_rz-0";